// @flow
import React, {PureComponent} from 'react'
import {FormattedMessage} from 'react-intl'
import {Header} from './header'
import {Cell} from './cell'
import {AriaHidden} from '../../shared/AriaHidden'
import {VisiblyHidden} from '../../shared/VisiblyHidden'
import {Endring} from '../../shared/Endring'
import {bem} from '../../shared/bem'
import {keyGenerator} from '../../shared/react-utils'
import {MandaterLargeSvg} from './svg/large-svg'
import {MandaterSmallSvg} from './svg/small-svg'
import {MandaterLargeFylkeSvg} from './svg/large-fylke-svg'
import {MandaterSmallFylkeSvg} from './svg/small-fylke-svg'
import {H} from '../../shared/H/index'

import {mandatfordelingTable} from './index.css'

export type MandatfordelingTableItem = {
  id: number,
  sortering: number,
  navn: string,
  kortNavn: string,
  antall: number,
  endringAntall: number
}

export type MandatfordelingTableProps = {
  items: Array<MandatfordelingTableItem>,
  type: 'land' | 'fylke',
  headingLevel: number
}

export class MandatfordelingTable extends PureComponent {
  props: MandatfordelingTableProps

  renderMandater(result: MandatfordelingTableItem, type: 'land' | 'fylke') {
    switch (type) {
      case 'fylke':
        return (
          <div>
            <MandaterLargeFylkeSvg result={result} />
            <MandaterSmallFylkeSvg result={result} />
          </div>
        )
      case 'land':
      default:
        return (
          <div>
            <MandaterLargeSvg result={result} />
            <MandaterSmallSvg result={result} />
          </div>
        )
    }
  }

  render() {
    const {items, type, headingLevel} = this.props
    return (
      <div className={bem(mandatfordelingTable, type, `${items.length}cols`)}>
        {[
          <Header type="parti" key="h0">
            <FormattedMessage
              id="mandattable.parti-heading"
              defaultMessage="PARTI"
            />
          </Header>,
          <Header type="tom" key="h1" />,
          <Header type="endring" key="h2">
            <FormattedMessage
              id="mandattable.endring-heading"
              defaultMessage="ENDRING"
            />
          </Header>
        ]}
        {[...items]
          .map((result, row) => {
            const {id, antall, endringAntall, navn, kortNavn} = result
            const gen = keyGenerator(id)
            return [
              <Cell type="parti" key={gen()} row={row}>
                <H level={headingLevel} title={navn}>
                  <AriaHidden>
                    {kortNavn}
                  </AriaHidden>
                  <VisiblyHidden>
                    {navn}
                  </VisiblyHidden>
                </H>
              </Cell>,

              <Cell type="mandater" key={gen()} row={row} offset={antall}>
                <AriaHidden>
                  <span data-selenium-id="mandater">
                    {antall}
                  </span>
                </AriaHidden>
                <VisiblyHidden>
                  <FormattedMessage
                    id="mandattable.antall-mandater"
                    values={{antall}}
                    defaultMessage="{antall} mandater"
                  />
                </VisiblyHidden>
              </Cell>,

              <Cell type="bar" key={gen()} row={row}>
                {this.renderMandater(result, type)}
              </Cell>,

              <Cell type="endring" key={gen()} row={row}>
                <AriaHidden>
                  <Endring endring={endringAntall} digits={0} />
                </AriaHidden>
                <VisiblyHidden>
                  {endringAntall > 0 &&
                    <FormattedMessage
                      id="mandattable.endring-mandater-positiv"
                      values={{endringAntall}}
                      defaultMessage="{endringAntall} opp fra 2013"
                    />}
                  {endringAntall === 0 &&
                    <FormattedMessage
                      id="mandattable.endring-mandater-ingen"
                      values={{endringAntall}}
                      defaultMessage="Ingen endring siden 2013"
                    />}
                  {endringAntall < 0 &&
                    <FormattedMessage
                      id="mandattable.endring-mandater-negativ"
                      values={{endringAntall: -endringAntall}}
                      defaultMessage="{endringAntall} ned fra 2013"
                    />}
                </VisiblyHidden>
              </Cell>
            ]
          })
          .reduce((res, value) => [...res, ...value], [])}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/mandatfordeling/MandatfordelingTable/index.js